import React from "react";
import { renderMetaTags } from "react-datocms";
import { Helmet } from "react-helmet";
import {useQuery} from "graphql-hooks";
import { useAPIErrorContext } from '../../contexts/apiErrorContext';

// init props var
type MetaTagsProps = {
    seoData: any;
}

// get default fallback metadata from CMS in case of missing routed page data
const CMS_QUERY = `query datoQuery {
    _site {
        globalSeo {
            fallbackSeo {
                description
            }
        }
    }
}`;

export const MetaTags: React.FunctionComponent<MetaTagsProps> = (props): JSX.Element => {
    // assign props to var
    const { seoData } = props;
    // load up query for fallback description
    const { loading, error, data } = useQuery(CMS_QUERY);
    // check for page data value
    if (seoData) {
        return (
            <Helmet>
                {renderMetaTags(seoData)}
            </Helmet>
        );
    }
    else {
        // check CMS query status
        if ((!error && !loading)) {
             return(
              <Helmet htmlAttributes={{ lang: "en" }}
                      meta={[
                    {
                      name: 'description',
                      content: data._site.globalSeo.fallbackSeo.description,
                    }
                  ]}
               />
              );
        }
        else {
            // set nothing in meta description if query failed
            return <Helmet/>
        }
    }
}
